var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"treatment-discussions"},[(_vm.isLoading)?_c('app-spinner'):_c('Message',{staticClass:"message",attrs:{"publicMessages":_vm.publicMessages,"maxHeight":false},on:{"saveMessage":_vm.onSaveMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }